import { extend } from 'vee-validate'
import { Validator } from '~/utility/Validator'

export class ReviewStarRatingValidator extends Validator<number> {}

extend('overallRateSelected', value => {
  if (value !== 0) return true
  return 'Please rate your stay'
})
